const test = {
  test: 'S15Q701'
};

export default test;



// WEBPACK FOOTER //
// ./src/api/module/test.js